import {  CommonModule  } from '@angular/common';
import {  Component     ,
          Input         } from '@angular/core';
import {  TranslatePipe } from 'nv@services/translate.service';

@Component({
  selector    : 'template-port-number',
  templateUrl : './template-port-number.component.html',
  imports     : [ CommonModule, TranslatePipe ]
})
export class TemplatePortNumber {

  @Input() public inputData: any;
  @Input() public inputIsVisible = false



}
